import { thejamsilFont } from 'src/styles/font';
import { rem } from 'src/styles/function';
import styled from 'styled-components';

/**
 * @name 전단 헤더 스타일 컴포넌트
 */
export const StyledHeader = styled.header`
  padding: ${rem(15)};
  box-sizing: border-box;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 999;
  h3 {
    ${thejamsilFont('regular')}
    text-align: center;
    font-size: ${rem(15)};
  }
  .header_area {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .header_homebtn,
    .header_appbtn {
      img {
        width: 100%;
      }
    }
    .header_homebtn {
      width: ${rem(70)};
      button {
        width: ${rem(32)};
        height: ${rem(32)};
      }
    }
    .header_appbtn {
      width: ${rem(70)};
      height: ${rem(32)};
    }
  }
`;
